var map = {
	"./badge.svg": "./vendor/ruby/3.2.0/bundler/gems/decidim-module-participatory-documents-21501f8563ea/app/packs/images/badge.svg",
	"./group.svg": "./vendor/ruby/3.2.0/bundler/gems/decidim-module-participatory-documents-21501f8563ea/app/packs/images/group.svg",
	"./move.svg": "./vendor/ruby/3.2.0/bundler/gems/decidim-module-participatory-documents-21501f8563ea/app/packs/images/move.svg",
	"./participatory_documents.svg": "./vendor/ruby/3.2.0/bundler/gems/decidim-module-participatory-documents-21501f8563ea/app/packs/images/participatory_documents.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./vendor/ruby/3.2.0/bundler/gems/decidim-module-participatory-documents-21501f8563ea/app/packs/images sync recursive ^\\.\\/.*$";